<script setup lang="ts">
import type { NuxtError } from '#app';
import VFooter from '~/components/VFooter.vue';
import Header from '~/components/header/Header.vue';
import VButton from '~/components/VButton.vue';

const props = defineProps<{ error: NuxtError }>();

const handleError = () => clearError({ redirect: '/' });
const handleOnPageUpdate = () => {
  location.reload();
  clearError();
};

console.error(props.error);
</script>
<template>
  <div class="error-page">
    <Header />
    <div class="container error-page-wrapper">
      <div class="error-content">
        <template v-if="error.statusCode == 404">
          <h1>404</h1>
          <div class="error-content__text">
            <h2>Такой страницы нет</h2>
            <p>Возможно, страница была удалена или в запросе был указан неверный адрес.</p>
          </div>
          <nuxt-link
            class="new-button new-button_secondary animation-scale"
            to="/"
          >
            На главную
          </nuxt-link>
        </template>
        <template v-else-if="error.statusCode == 502">
          <h1>502</h1>
          <div class="error-content__text">
            <h2>Выполняется обновление...</h2>
            <p>Попробуйте обновить страницу или зайти через несколько минут.</p>
          </div>
        </template>
        <template v-else>
          <h1>Упс!</h1>
          <div class="error-content__text">
            <h2>Что-то пошло не так...</h2>
            <p>Мы знаем о проблеме и уже работаем. Попробуйте обновить страницу или зайти попозже.</p>
          </div>
          <v-button
            class="animation-scale"
            @click="handleOnPageUpdate"
          >
            Обновить страницу
          </v-button>
          <v-button
            class="animation-scale"
            schema="secondary"
            @click="handleError"
          >
            На главную
          </v-button>
        </template>
      </div>
    </div>
    <v-footer />
  </div>
</template>
<style lang="scss">
.error-page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  padding-top: 100px;

  .error-page-wrapper {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .footer-new {
    width: 100%;
    @include media-breakpoint-up(lg) {
      padding: 50px 0;
    }
  }

  .error-content {
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    gap: 30px;

    h1 {
      color: $foreground-theme;
      text-align: center;
      font-size: 120px;
      font-weight: 200;
      line-height: 120px;
      margin-bottom: 0;
      @include media-breakpoint-down(md) {
        font-size: 80px;
        line-height: 80px;
      }
    }

    .error-content__text {
      text-align: center;

      h2 {
        color: $foreground-contrast;
        font-size: 32px;
        font-weight: 600;
        line-height: 36px;
        margin-bottom: 16px;
        @include media-breakpoint-down(md) {
          font-size: 28px;
        }
      }

      p {
        color: $foreground-gray;
        font-size: 18px;
        line-height: 28px;
        font-weight: 400;
        @include media-breakpoint-down(md) {
        }
      }
    }
  }
}
</style>
